import { useEffect, useRef, useState } from 'react';

const STEPS = [
  { num: '01', title: 'Book Appointment', desc: 'Choose your service and preferred time. Simple, fast, and flexible.' },
  { num: '02', title: 'Consult & Design', desc: 'We discuss your style, shape, and every detail before we begin.' },
  { num: '03', title: 'Get Your Set', desc: 'Precision application, flawless finish. Leave feeling like yourself — elevated.' },
];

export default function HowItWorks() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) setVisible(true); }, { threshold: 0.2 });
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <section id="how-it-works" ref={ref} className="bg-blush-light py-24 md:py-32 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="font-sans text-xs tracking-widest2 uppercase text-gold block mb-4">The Process</span>
          <h2 className={`font-serif text-4xl md:text-5xl text-ink font-light transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>How It Works</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-0 md:gap-0 relative">
          {STEPS.map((s, i) => (
            <div key={i} className={`relative flex flex-col items-center text-center px-8 py-10 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${i * 180 + 200}ms` }}>
              {i < STEPS.length - 1 && (
                <div className="hidden md:block absolute top-10 right-0 w-px h-20 bg-blush-deep translate-x-0" />
              )}
              <span className="font-serif text-6xl md:text-7xl font-light text-blush-deep leading-none mb-4">{s.num}</span>
              <div className="w-8 h-px bg-gold mb-5" />
              <h3 className="font-serif text-xl md:text-2xl text-ink font-medium mb-3">{s.title}</h3>
              <p className="font-sans text-sm text-ink-muted leading-relaxed max-w-xs">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
